

















import Vue from "vue";
import { SelectOption } from "../types";

export default Vue.extend({
  props: {
    option: {
      type: Object as () => SelectOption,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    toggle() {
      this.$emit("input", this.option.key, !this.selected);
    }
  }
});
